import { api } from "./api"

export const SEARCH_CONTENTS_BY_KEYWORD = async (keyword) => {
    const {data} = await api.get("/contents/search/by/keyword", {params: {keyword}})
    return data;
}

export const SEARCH_CONTENTS_SPECIFIC = async (params) => {
    const {data} = await api.get("/contents/search/specific", {params})
    return data;
}
